// extracted by mini-css-extract-plugin
module.exports = {"card":"Promote_card__3b2Fl"};